import React, { ChangeEvent, useEffect, FC } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { validateEmail } from '@qred/shared-component-library/src/validators';
import { setInvalidError, setMissingError } from '~/actions/errorActions';
import { IBaseComponent } from '../../sharedInterfaces/IBaseComponent';
import { EMAIL_ADDRESS } from '~/actions/actionTypes';
import { setInput, validateValue } from '~/actions/formActions';
import { IState } from '~/sharedInterfaces/IState';
import Input from '../Base/Input/Input';
import { IBaseInput } from '~/sharedInterfaces/SharedInterfaces';

export interface IEmailAddress extends IBaseInput {}

export interface IEmailAddressProps extends IEmailAddress, IBaseComponent {}

const Email: FC<IEmailAddressProps> = (props) => {
  const dispatch = useDispatch();
  const value = useSelector((state: IState) => state.signup.emailAddress || '');
  const error = useSelector((state: IState) => state.error.emailAddress);
  const { locale } = useSelector((state: IState) => state.widgetContext);

  const handleValidation = () => {
    dispatch(validateValue(validateEmail, EMAIL_ADDRESS, value, locale));
  };

  const handleOnChange = (event: ChangeEvent<HTMLInputElement>) => {
    const inputValue = event.target.value;
    dispatch(setInput(EMAIL_ADDRESS, inputValue));
    if (error?.missing) dispatch(setMissingError(EMAIL_ADDRESS, ''));
  };

  useEffect(() => {
    const validEmail = validateEmail(value);
    if (validEmail && error?.invalid) dispatch(setInvalidError(EMAIL_ADDRESS, ''));
  }, [value]);

  return (
    <Input
      {...props}
      value={value}
      error={error?.missing || error?.invalid}
      handleValidation={handleValidation}
      onChange={handleOnChange}
      analyticsEvent="email"
      inputMode="email"
      autoCapitalize="none"
      autoCorrect="off"
      spellCheck={false}
    />
  );
};

export default Email;
